import { FC, useState, useEffect } from 'react';
import zapInput from '../../assets/zapschematics/Zap-input.png';
import zapOutput from '../../assets/zapschematics/Zap-output.png';

const IntroStep: FC = () => {
  const images = [zapInput, zapOutput];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
        setIsTransitioning(false);
      }, 500); // Half of the transition duration
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(timer);
  }, [images.length]);

  return (
    <div className="space-y-1">
      <h2 className="text-2xl font-bold text-white">Onboard your Zap</h2>
      <div className="relative h-64 w-full overflow-hidden">
        <img
          src={images[currentImageIndex]}
          alt={`Zap setup step ${currentImageIndex + 1}`}
          className={`absolute inset-0 h-full w-full object-contain transition-opacity duration-1000 ${
            isTransitioning ? 'opacity-0' : 'opacity-100'
          }`}
        />
      </div>
      <div className="space-y-1 text-gray-300">
      <ol className="list-decimal list-inside space-y-2 mt-2">
        <li>Plug in your Zap to your p1 port.</li>
        <li>The status led should blink once and then shine with a steady blue light indicating the Zap is in pairing mode.</li>
        <li>click 'Next' to begin the setup process.</li>
        </ol>
      </div>
    </div>
  );
};

export default IntroStep; 